/* eslint-disable class-methods-use-this */
import { v4 } from 'uuid';

import { ControllerContext } from './controller-context.class';
import { ControllerRootBase } from './controller-root-base.class';
import { ControllerNodeOptions, EventMessage, EventPayloadCrud } from './types';

export class ControllerNodeBase<
	SerializedDataType = null,
	InstanceOfType = string,
	ParentType extends (ControllerRootBase | ControllerNodeBase) = null,
	ContextType extends ControllerContext = ControllerContext
> extends ControllerRootBase<
	SerializedDataType,
	ContextType
> {
	#instanceParent: ParentType;

	constructor (instanceOf: InstanceOfType, options: ControllerNodeOptions<SerializedDataType> = {}, context: ContextType = null) {
		super(
			instanceOf as string,
			options,
			(context === null && options.parent ? options.parent.context : context) as ContextType
		);
		// console.log(`Instanciated --> ${options.parent?.instanceOf} -> ${instanceOf}`, options.parent?.context, this.context);
		this.#instanceParent = options.parent ?? null;
	}

	get instanceParent (): ParentType { return this.#instanceParent; }

	public findParentInstanceOf <P extends ControllerRootBase> (typeName: InstanceOfType, depth = 0): P | null {
		let instance = null;

		if (this.instanceParent !== null && this.instanceParent instanceof ControllerNodeBase) {
			if (this.instanceParent.instanceOf === typeName) {
				instance = this.instanceParent as unknown as P;
			} else {
				instance = this.instanceParent.findParentInstanceOf<P>(typeName as string, (depth + 1)) as P;
			}
		}
		return instance;
	}

	public publishEvent (message: EventMessage): void {
		// console.log(`publishEvent(node):${message.noun}:${message.action}`, this.instanceOf);
		super.publishEvent(message);
		if (this.instanceParent !== null) this.instanceParent.publishEvent(message);
	}
}
